import React from "react";
import { removeBlacklistProps } from "../utils";

export default blacklist =>
  React.forwardRef((props, ref) => {
    const { el, ...rest } = props;
    const filteredProps = removeBlacklistProps(Object.keys(blacklist), rest);
    return React.createElement(el, { ref, ...filteredProps });
  });
